import "./style.css";
import { HeaderSkeleton } from "./header-skeleton";
import { SubHeaderSkeleton } from "./sub-header-skeleton";
import { InputSkeleton } from "./input-skeleton";
import { TextAreaSkeleton } from "./text-area-skeleton";
import { ButtonSkeleton } from "./button-skeleton";

export const SchemaSkeleton = () => (
    <div
        style={{
            padding: '24px',
            borderRadius: '5px',
            background: 'rgba(255, 254, 255, 0.2)'
        }}
        className="flex-center-column"
    >
        <HeaderSkeleton/>
        <SubHeaderSkeleton style={{ marginBottom: '32px' }}/>
        <InputSkeleton style={{ marginBottom: '24px' }}/>
        <InputSkeleton style={{ marginBottom: '24px' }}/>
        <TextAreaSkeleton style={{ marginBottom: '24px' }}/>
        <ButtonSkeleton/>
    </div>
);